export default __webpack_public_path__ + "static/media/1839.55b75beb.png";